module.exports = __webpack_public_path__ + "cy.b5afa9ddf83cb107a9da.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cy.svg
// module chunks = styles